import { registerPlugin } from '@capacitor/core';

import type { JustWeiWechatPlugin } from './definitions';

const JustWeiWechat = registerPlugin<JustWeiWechatPlugin>('JustWeiWechat', {
  web: () => import('./web').then((m) => new m.JustWeiWechatWeb()),
});

export * from './definitions';
export { JustWeiWechat };
